import { useState } from "react";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useOrganization } from "../../store/organization";

export function Specs() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [isOpenSpecsDetail, setOpenSpecsDetail] = useState(false);

  const { organization } = useOrganization();
  const landingDetails = organization.data.landingDetails;

  return (
    <Grid
      container={true}
      item={true}
      mt={{ md: "80px", xs: "32px" }}
      md={true}
      sx={{ flexDirection: "column" }}
    >
      <Grid item={true} md={9} sm={12} xs={12} mx="auto">
        <img
          src={landingDetails.specs.imageUrl}
          alt="Spec image"
          height="auto"
        />
      </Grid>

      <h3 className="tw-text-2xl tw-font-bold tw-text-center tw-my-8">
        {landingDetails.specs.headerText}
      </h3>

      <Grid
        container={true}
        item={true}
        className="tw-px-2 tw-py-8 md:tw-py-20 tw-text-white tw-bg-black"
        justifyContent="center"
        spacing={{ xs: 1, sm: 0 }}
      >
        {landingDetails.specs.points.map((point) => (
          <Grid item={true} xs={6} sm={4} rowSpacing={4} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <img
              className="tw-w-12 tw-h-8 tw-object-contain tw-mb-4 tw-mx-auto tw-mt-4"
              src={point.iconUrl}
              alt="Point Icon"
            />
            <p className="tw-font-bold tw-text-center tw-mb-9 tw-mx-4">{point.text}</p>
          </Grid>
        ))}
      </Grid>

      {isMobile && (
        <a
          className="tw-text-center tw-py-8"
          onClick={() => setOpenSpecsDetail(!isOpenSpecsDetail)}
        >
          {isOpenSpecsDetail ? "Click to close tech specs" : "Clieck to open all e-bike specs"}
        </a>
      )}

      {((isMobile && isOpenSpecsDetail) || !isMobile) && (
        <Grid
          item={true}
          className="xs:tw-px-5"
          md={9}
          sm={11}
          xs={11}
          mx="auto"
          mt={{ md: "80px" }}
          pb="100px"
        >
          {landingDetails.specs.expendedInfo.map((info) => (
            <div
              key={info.id}
              className="tw-flex tw-max-w-3xl tw-py-4 tw-border-b tw-justify-between tw-gap-3 tw-w-full"
            >
              <p className="tw-text-xs tw-self-end">{info.text}</p>
              <p
                className="tw-text-sm tw-font-bold "
                style={{
                  width: "60%",
                }}
              >
                {info.description}
              </p>
            </div>
          ))}
        </Grid>
      )}
    </Grid>
  );
}
